import request from '@/service/api'
import ConfigType from '@/service/api/type'
//平台管理API
enum PlatformApi {
    // 菜单管理
    MENU_LIST = '/sysMenu/list', //查询
    MENU_DEL = '/sysMenu/delete', //删除
    MENU_ADD = '/sysMenu/add', //新增
    MENU_EDIT = '/sysMenu/edit', //编辑
    MENU_TREE = '/sysMenu/tree?application=busiapp', //获取菜单级联选择
    //pda菜单管理
    PDAMENU_PAGE= '/wmspdapower/page', //查询
    PDAMENU_DEL = '/wmspdapower/delete', //删除
    PDAMENU_ADD = '/wmspdapower/add', //新增
    PDAMENU_EDIT = '/wmspdapower/edit', //编辑
   
    // 异常日志
    EXLOG_LIST = '/sysExLog/page', //查询
    // 操作日志
    LOG_LIST = '/sysOpLog/page', //查询
    // 访问日志
    VISLOG_LIST = '/sysVisLog/page', //查询
    // 任务调度
    TIMERSLIST = '/sysTimers/page',//查询
    TIMERSADD = '/sysTimers/add',//新增
    TIMERSEDIT = '/sysTimers/edit',//编辑
    TIMERSDELETE = '/sysTimers/delete',//删除
    STARTUP = 'sysTimers/StartTimerJob'//启动
}
/******************************************************************************************菜单管理******************************************************************************************/
//查询
export const getMneusList = (data: any): ConfigType<any> => {
    return request({
        url: `${PlatformApi.MENU_LIST}`,
        params: data
    })
}

//删除
export const delMenu = (data: any): ConfigType<any> => {
    return request({
        url: PlatformApi.MENU_DEL,
        method: 'post',
        data
    })
}

//新增
export const addMenu = (data: any): ConfigType<any> => {
    return request({
        url: PlatformApi.MENU_ADD,
        method: 'post',
        data
    })
}

//编辑
export const editMenu = (data: any): ConfigType<any> => {
    return request({
        url: PlatformApi.MENU_EDIT,
        method: 'post',
        data
    })
}

//获取菜单级联选择
export const getMneusTree = (): ConfigType<any> => {
    return request({
        url: PlatformApi.MENU_TREE,

    })
}

/******************************************************************************************pda菜单管理******************************************************************************************/
//查询
export const getPdaMneusPage = (data: any): ConfigType<any> => {
    return request({
        url: `${PlatformApi.PDAMENU_PAGE}`,
        params: data
    })
}

//删除
export const delPdaMenu = (data: any): ConfigType<any> => {
    return request({
        url: PlatformApi.PDAMENU_DEL,
        method: 'post',
        data
    })
}

//新增
export const addPdaMenu = (data: any): ConfigType<any> => {
    return request({
        url: PlatformApi.PDAMENU_ADD,
        method: 'post',
        data
    })
}

//编辑
export const editPdaMenu = (data: any): ConfigType<any> => {
    return request({
        url: PlatformApi.PDAMENU_EDIT,
        method: 'post',
        data
    })
}

/******************************************************************************************异常日志******************************************************************************************/
//查询
export const getELogList = (data: any): ConfigType<any> => {
    return request({
        url: `${PlatformApi.EXLOG_LIST}`,
        params: data
    })
}
/******************************************************************************************操作日志******************************************************************************************/
// 查询
export const getLogList = (data: any): ConfigType<any> => {
    return request({
        url: `${PlatformApi.LOG_LIST}`,
        params: data
    })
}
/******************************************************************************************访问日志******************************************************************************************/
// 查询
export const getVisLog = (data: any): ConfigType<any> => {
    return request({
        url: `${PlatformApi.VISLOG_LIST}`,
        params: data
    })
}
/******************************************************************************************任务调度******************************************************************************************/
// 查询
export const getTimersList = (data: any): ConfigType<any> => {
    return request({
        url: `${PlatformApi.TIMERSLIST}`,
        params: data
    })
}
// 新增
export const addTimersList = (data: any): ConfigType<any> => {
    return request({
        url: PlatformApi.TIMERSADD,
        method: 'post',
        data: data
    })
}
//编辑
export const editTimersList = (data: any): ConfigType<any> => {
    return request({
        url: PlatformApi.TIMERSEDIT,
        method: 'post',
        data: data
    })
}
// 删除
export const deleteTimersList = (data: any): ConfigType<any> => {
    return request({
        url: PlatformApi.TIMERSDELETE,
        method: 'post',
        data: data
    })
}
//启动
export const startList = (): ConfigType<any> => {
    return request({
        url: `${PlatformApi.STARTUP}`
        
    })
}